
import SubscriptionSelectModal from '../obs/SubscriptionSelectModal'

export default {
  name: 'DownloadOverlayButton',
  components: { SubscriptionSelectModal },
  props: {
    themeId: {
      type: [String, Number],
      default: 0
    },
    isPro: {
      type: Boolean,
      default: false
    },
    buttonClass: {
      type: String,
      default: ''
    },
    language: {
      type: String,
      default: 'en'
    }
  },
  data () {
    return {
      canConsume: false,
      showSubscriptionPlans: false,
      entitlement: {}
    }
  },

  computed: {
    showProText () {
      return this.isPro && (!this.$auth.user.subscription || !this.$auth.user.subscription.is_active)
    }
  },

  methods: {
    async download () {
      if (!this.$isOBS) {
        this.canConsume = true

        return
      }

      try {
        this.entitlement = await this.$store.dispatch('consume/consumeEntitlement', {
          id: this.themeId,
          type: 'themes',
          confirmed: true,
          language: this.language
        })

        const url = this.entitlement.data.sku.download_url_encoded
        const name = encodeURIComponent(this.entitlement.data.sku.name)
        const hash = this.entitlement.data.sku.download_hash

        window.location = process.env.API_URL + `obs/download/?theme-url=${url}&theme-name=${name}&theme-hash=${hash}`
      } catch (error) {
        if (error.message === '409') {
          this.showSubscriptionPlans = true
        }
      }
    }
  }
}
